export const TIDS = {
  // Header
  headerLogo: "header-logo",
  navServices: "nav-services",
  navPackages: "nav-packages",
  navAbout: "nav-about",
  navContact: "nav-contact",
  headerCta: "header-cta",
  langSwitcher: "lang-switcher",
  langIt: "lang-it",
  langEn: "lang-en",
  mobileMenuToggle: "mobile-menu-toggle",

  // Hero
  heroTitle: "hero-title",
  heroCtaPrimary: "hero-cta-primary",
  heroCtaSecondary: "hero-cta-secondary",
  heroGraphic: "hero-graphic",

  // Services
  servicesSection: "services-section",
  serviceCard: "service-card",

  // Pricing
  pricingSection: "pricing-section",
  pricingCard: "pricing-card",
  pricingBuyBtn: "pricing-buy-btn",

  // Configurator
  configuratorSection: "configurator-section",
  configHours: "config-hours",
  configComplexity: "config-complexity",
  configUrgency: "config-urgency",
  configDescription: "config-description",
  configBudget: "config-budget",
  configName: "config-name",
  configEmail: "config-email",
  configCompany: "config-company",
  configSubmit: "config-submit",

  // Testimonials
  testimonialsSection: "testimonials-section",
  testimonialCard: "testimonial-card",

  // About
  aboutSection: "about-section",

  // Final CTA
  finalCtaSection: "final-cta-section",
  finalCtaBtn: "final-cta-btn",

  // Footer
  footerSection: "footer-section",

  // Booking modal
  bookingDialog: "booking-dialog",
  bookingName: "booking-name",
  bookingEmail: "booking-email",
  bookingPhone: "booking-phone",
  bookingCompany: "booking-company",
  bookingMessage: "booking-message",
  bookingSubmit: "booking-submit",

  // Checkout
  checkoutDialog: "checkout-dialog",
  checkoutFullName: "checkout-full-name",
  checkoutEmail: "checkout-email",
  checkoutCompany: "checkout-company",
  checkoutVat: "checkout-vat",
  checkoutMethodNexi: "checkout-method-nexi",
  checkoutMethodViva: "checkout-method-viva",
  checkoutSubmit: "checkout-submit",
  checkoutCancel: "checkout-cancel",
};
